import React from "react";


// Custom Components
import bannerBg from '../../assets/img/landing-page/landing-page-bg.png';

// Images
//import images from "../B2BDatabase/images";
//import B2bdatabaseHome from "./components/home";
//import LandingPageTestimonial from "../../components/landingPageTestimonial/landingPageTestimonial";
//import B2bFaqs from "./components/b2bfaq";
const CompanyInfo = () => {
  return (
    <div className="main-body">
      <div style={{ position: "relative", zIndex: 1 }}>
        {/* Section */}
        <section
          style={{
            backgroundImage: `url(${bannerBg})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            paddingTop: "3rem", // Adjust spacing above the text column
            paddingBottom: "6rem",
            position: "relative", // Ensure the section context for the overlapping image
          }}
        >
          
          


        </section>

          <div className="container py-5">
      {/* Hero Section */}
      <section className="company-hero mb-5">
        <div className="d-flex flex-lg-row flex-column gap-4">
          {/* Left Side - Company Info */}
          <div className="flex-grow-1">
            <div className="bg-white p-5 rounded-3 shadow-sm">
              <div className="d-flex align-items-start gap-5">
                <img 
                  src="https://www.lusha.com/wp-content/themes/lusha/assets/img/templates/directory2/company_fallback.svg" 
                  alt="Company Logo"
                  className="rounded-circle"
                  style={{ width: '150px', height: '150px' }}
                />
                <div>
                  <h1 className="display-5 fw-bold mb-3">AAT-FINANCE SIA</h1>
                  <a 
                    href="https://www.corsax.lv" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-decoration-none h5 text-primary"
                  >
                    www.corsax.lv
                  </a>
                  <p className="mt-3 text-secondary">
                    We provide accounting services to small and medium size companies operating in Riga, Latvia...
                    <button className="btn btn-link p-0 ms-2">Read more</button>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - CTA */}
          <div className="flex-shrink-0" style={{ width: '320px' }}>
            <div className="bg-white p-4 rounded-3 shadow-sm text-center">
              <h2 className="h4 fw-bold mb-3">
                Reach decision makers at<br/>AAT-FINANCE SIA
              </h2>
              <img 
                src="https://www.lusha.com/wp-content/themes/lusha/assets/img/templates/directory2/Hat_Wand.svg" 
                alt="Magic Wand" 
                className="my-4"
                style={{ width: '60px' }}
              />
              <div className="d-flex flex-column gap-3">
                <button className="btn btn-primary btn-lg">
                  Contact Sales
                </button>
                <button className="btn btn-outline-primary btn-lg">
                  Find Them Free
                </button>
              </div>
              <p className="text-muted small mt-3">
                Free credit every month!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Grid */}
      <div className="row g-4">
        {/* Left Column - Company Details */}
        <div className="col-lg-4">
          <div className="bg-white p-4 rounded-3 shadow-sm">
            <h2 className="h5 fw-bold mb-4">Company Details</h2>
            <div className="d-flex flex-column gap-3">
              <DetailItem 
                icon="globe" 
                title="Country" 
                value="Latvia" 
              />
              <DetailItem 
                icon="building" 
                title="Industry" 
                value="Accounting" 
              />
              <DetailItem 
                icon="people" 
                title="Employees" 
                value="1-10" 
              />
              <DetailItem 
                icon="calendar" 
                title="Founded" 
                value="2011" 
              />
              <div className="d-flex align-items-center gap-3">
                <i className="bi bi-linkedin fs-5"></i>
                <a href="#" className="text-decoration-none">LinkedIn Profile</a>
              </div>
            </div>
          </div>
        </div>

        {/* Middle Column - Employees */}
        <div className="col-lg-4">
          <div className="bg-white p-4 rounded-3 shadow-sm mb-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="h5 fw-bold m-0">Employees Statistics</h2>
              <button className="btn btn-link">View all</button>
            </div>
            <div className="d-flex gap-3">
              <StatBadge count={1} label="Others" />
            </div>
          </div>

          <div className="bg-white p-4 rounded-3 shadow-sm">
            <h2 className="h5 fw-bold mb-4">Potential Decision Makers</h2>
            <div className="border rounded-3 p-3">
              <h3 className="h6 fw-bold">Partner</h3>
              <div className="text-muted my-2">
                <div>Email: ******@****.com</div>
                <div>Phone: (***) ****-****</div>
              </div>
              <button className="btn btn-outline-secondary w-100">
                Show Details
              </button>
            </div>
          </div>
        </div>

        {/* Right Column - Tech & Related */}
        <div className="col-lg-4">
          <div className="bg-white p-4 rounded-3 shadow-sm mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="h5 fw-bold m-0">Technologies</h2>
              <span className="badge bg-primary">15</span>
            </div>
            <div className="input-group mb-3">
              <input 
                type="text" 
                className="form-control" 
                placeholder="Search technology"
              />
            </div>
            <div className="d-flex flex-wrap gap-2">
              <TechTag label="Google Analytics" />
              <TechTag label="React" />
              <TechTag label="AWS" />
              <button className="btn btn-link p-0">View all (15)</button>
            </div>
          </div>

          <div className="bg-white p-4 rounded-3 shadow-sm">
            <h2 className="h5 fw-bold mb-3">Similar Companies</h2>
            <p className="text-muted small mb-3">Accounting companies from Latvia</p>
            <div className="d-flex flex-column gap-2">
              <RelatedCompany name="SIA Business Latvia" />
              <RelatedCompany name="ECB SIA" />
              <RelatedCompany name="LOVAT COMPLIANCE LTD" />
            </div>
          </div>
        </div>
      </div>
    </div>
            
      </div>

     
    </div>
  );
};

// Reusable Components
const DetailItem = ({ icon, title, value }) => (
    <div className="d-flex align-items-center gap-3">
      <i className={`bi bi-${icon} fs-5`}></i>
      <div>
        <div className="text-muted small">{title}</div>
        <div className="fw-medium">{value}</div>
      </div>
    </div>
  );
  
  const StatBadge = ({ count, label }) => (
    <div className="bg-light rounded-3 p-3 text-center flex-grow-1">
      <div className="h4 mb-1">{count}</div>
      <div className="small">{label}</div>
    </div>
  );
  
  const TechTag = ({ label }) => (
    <span className="badge bg-light text-dark border rounded-pill px-3 py-2">
      {label}
    </span>
  );
  
  const RelatedCompany = ({ name }) => (
    <a href="#" className="text-decoration-none d-block p-2 rounded-2 hover-bg">
      <div className="fw-medium">{name}</div>
      <div className="small text-primary">Show more</div>
    </a>
  );

export default CompanyInfo;
